import { render } from "./Dialogue.vue?vue&type=template&id=45656ad7"
import script from "./Dialogue.vue?vue&type=script&lang=js"
export * from "./Dialogue.vue?vue&type=script&lang=js"

import "./Dialogue.vue?vue&type=style&index=0&id=45656ad7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__